import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// material-ui
import { Box, ButtonBase, Typography } from '@mui/material';

// project import
import LogoMain from './LogoMain';
import LogoIcon from './LogoIcon';
import config from 'config';

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = ({ reverse, isIcon, sx, to }) => (
  <ButtonBase disableRipple component={Link} to={!to ? config.defaultPath : to} sx={sx}>
    {/*{isIcon ? <LogoIcon /> : <LogoMain reverse={reverse} />}*/}
    <Typography variant="h3">Cygnus Dashboard</Typography>
  </ButtonBase>
);

LogoSection.propTypes = {
  reverse: PropTypes.bool,
  isIcon: PropTypes.bool,
  sx: PropTypes.object,
  to: PropTypes.string
};

export default LogoSection;
